import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AnnotationPlatform } from '@/components/annotation';

export function AnnotationPage() {
  const navigate = useNavigate();

  const handleComplete = (sessionId: string, participantId: string) => {
    console.log('Session completed:', { sessionId, participantId });
    navigate('/');
  };

  const handleBack = () => {
    navigate('/');
  };

  return (
    <AnnotationPlatform 
      onComplete={handleComplete}
      onBack={handleBack}
      className="w-full"
    />
  );
}